import {LandingInfoInterface} from "@/views/Admin/Events/Event/General/Info/Section/LandingInfo/LandingInfo.interface";
import {FieldSchema} from "@/schema/Field.schema";

export const LandingInfoSchema: LandingInfoInterface = {
    copyUrlText: 'копировать',
    domainAfisha: null,
    isChangeUrlModal: false,
    isEditSlug: false,
    generateSlugInput: FieldSchema,
    newSlug: null,
}
